import { render } from "./FavoriteIcon.vue?vue&type=template&id=c4445d8e&scoped=true"
import script from "./FavoriteIcon.vue?vue&type=script&lang=js"
export * from "./FavoriteIcon.vue?vue&type=script&lang=js"

import "./FavoriteIcon.vue?vue&type=style&index=0&id=c4445d8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4445d8e"]])

export default __exports__